import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

/**
 * "Option 3" — the number the chat text gives this card, as a tab on the
 * card's top edge (bot.less `.bot-result-card-wrapper__option-tab`). While the
 * cards are on screen the chat hides the numbered list text
 * (bot-core/utils/parseCardLists.ts), so the tab is what lets the user say
 * "option 3" without counting cards. Rendered as the first child of a
 * `bot-result-card-wrapper--numbered` wrapper.
 */
const OptionNumberTab: React.FC<{ number: number }> = ({ number }) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);
  const label = (t?.result?.optionNumber ?? 'Option {{number}}').replace(
    '{{number}}',
    String(number),
  );
  return <span className="bot-result-card-wrapper__option-tab">{label}</span>;
};

export default OptionNumberTab;
